module.exports = __webpack_public_path__ + "img/生产经营一体化解决方案.541c5853.jpg";